import { Component, OnInit } from "@angular/core";
import { IgniteImageDef } from "libs/ui-common/src/lib/models/ignite-image-def";

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.scss"],
  standalone: false,
})
export class DashboardComponent implements OnInit {
  imageDefs: IgniteImageDef[];

  ngOnInit(): void {
    this.imageDefs = [];
    this.imageDefs.push({
      imageUrl: "/assets/images/learn/guided_practice_all_skills.png",
      title: "Skills",
      description: "Guided practice all skills",
      expandable: true,
      width: "300px",
    });
    this.imageDefs.push({
      imageUrl: "/assets/images/learn/guided_practice_listening.png",
      title: "Listening",
      description: "Guided practice listening",
      expandable: true,
      width: "300px",
    });
    this.imageDefs.push({
      imageUrl: "/assets/images/learn/guided_practice_reading.png",
      title: "Reading",
      description: "Guided practice reading",
      expandable: true,
      width: "300px",
    });
    this.imageDefs.push({
      imageUrl: "/assets/images/learn/guided_practice_writing.png",
      title: "Writing",
      description: "Guided practice writing",
      expandable: true,
      width: "300px",
    });
  }
}
